var antPrefixCls = '.ant-alert';
var alertStyleFn = function alertStyleFn(token) {
  var _ref, _antPrefixCls, _ref2;
  return _ref2 = {}, _ref2[antPrefixCls] = (_antPrefixCls = {
    border: token.lineWithNone
  }, _antPrefixCls["&" + antPrefixCls + "-with-description"] = (_ref = {
    '.ant-alert-icon': {
      marginTop: 2,
      marginInlineEnd: 8
    }
  }, _ref[antPrefixCls + "-message"] = {
    fontWeight: 500,
    marginBottom: 4
  }, _ref[antPrefixCls + "-description"] = {
    color: token.colorTextTertiary
  }, _ref), _antPrefixCls), _ref2;
};

export { alertStyleFn };
